const EndPoints = {
  AdminLogin: "/auth/login",
  ForgotPassword: "/verifications/forgot/password",
  ResetPassword: "/verifications/reset/",
  ViewCards: "/cards/v1",
  EditCard: "/cards/edit",
  CardInfo: "/cards/details",
  Cards: "/cards",

  DashboardGraph: "/admin/dashboard/graph",
  DashboardDetails: "/admin/dashboard",

    ProfileCardInfo: '/users/card/details',
    PendingCards: '/cards/requests/pending',
    MergeRequests: '/cards/requests/',
    ApproveCards: '/cards/requests/approve',
    DeleteRequests: '/cards/requests',
    DeclineEmail: '/cards/requests/decline-email',

  MessagesList: "/messages/all",
  MessagesReply: "/messages/reply",
  DeleteMessages: "/messages/remove",
  MessageDetails: "/messages/details",
  MessageToUser: "/users/contact",

  AddAdmin: "/auth/signup/admin",
  EditAdmin: "/users/admin",
  DeleteAdmins: "/users",

  Accounts: "/users",
  DeleteAccounts: "/users",
  SuspendAccounts: "/users",
  GetCSV: "/users",

  Profiles: "/profiles",
  ProfileIssuerCards: "/profiles/cardlist",
  DeleteProfiles: "/profiles/remove",
  AddIssuer: "/issuers",
  EditIssuer: "/issuers",
  DeleteIssuer: "/issuers",
  GetIssuerCards: "/mobile/issuers",

  IssuerColors: "/mobile/issuers/colors",
  Settings: "/users/edit/personal/data",
  GetRules: "/rules/all",
  Rules: "/issuers/rules",

  Users: "/users",
  UsersSettings: "/admin",

  PointCategories: "/point-categories",
  PatchPointCategory: (categoryId) => `/point-categories/${categoryId}`,
  PatchPlaidPointCategory: (categoryId) => `/point-categories/plaid/${categoryId}`,

  GetSubcategories: { prefix: "/point-categories/", suffix: "/details" },
  GetCategoryById: "/pointcategories/",
  SavePointsCategory: "/point-categories/user-bonus-category",
  AdminSaveSinglePointCategory: "/point-categories",

  Offers: "/offers",

  Issuers: "/issuers",

  CheatSheet: "/cheatSheet",

  GetPromos: "/promos/promos-and-hashtags",
  GetCardsAndPromos: "/promos/cards-and-promos",
  AddPromo: "/promos",
  GetAllPromos: "/promos",
  PromoDetail: "/promos/",
  EditPromo: "/promos/",
  DeletePromo: "/promos/",
  PopulateCreditPerks: { prefix: "/promos/", suffix: "/credits-and-perks" },
  GetUserPromos: "/promos/user-created-promos",
  RemoveUserCreatedPromos: "/promos",

  BonusCategory: "/admin/bonus-categories",
  ApproveBonusCategory: "/user-bonus-category",

  GetBonusCategoryList: "/customBonusCategory/newBonusCategoryDetail",
  DeleteBonusCategory: "/customBonusCategory/adminDeleteCategory",
  EditCardBonusCategory: "/cards/CarddetailsBonusCategory",
  DenyBonusCategory: "/customBonusCategory/adminDenyCategory",

  SearchPlaidInstitutions: "/plaid/search-institutions",
  FetchAllMerchants: "/transactions/resources?type=merchants",
  UpdateMerchantsStatus: (merchantId) => `/transactions/admin/merchants/${merchantId}`
};

export default EndPoints;
